
<template>
  <div class="fertilizer">
    <div class="box">
      <img src="./red.gif" width="500" height="80" alt="Product RED">
    </div>
    <div class="updated">6 XI 2006</div>
  </div>
</template>

<script>
export default {
  name: "red"
};
</script>

<style scoped>
.fertilizer {
  background-color: #ff0000;
}

.box {
  margin-top: -40px;
}

.updated {
  color: #a80f30;
}
</style>

